import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Role, UserService} from '@cnj/uikit';
import {Observable} from 'rxjs';
import {environment} from 'src/app/environment';

export interface RolesFile {
    role: Role;
    acessos: {
        action: string[];
        resource: string;
        client: string
    }[]
}

// Classe responsável por buscar permissões do usuário e tratar sobre a inclusão delas no objeto User

@Injectable({
    providedIn: 'root'
})
export class SisnorAuthService {
    file;

    constructor(
        protected http: HttpClient,
        protected userService: UserService) {
    }

    //TODO: verificar melhor maneira de ler os dados
    public carregarPermissoes() {
        this.file = {
            appRoles: [
                {
                    role: "USUARIO_EXTERNO",
                    acessos: [
                        { action: ["Acessar"], resource: "Aplicação", client: null },
                        { action: ["Listar"], resource: "Declaracao", client: null },
                        { action: ["Cadastrar"], resource: "Declaracao", client: null },
                        { action: ["Editar"], resource: "Declaracao", client: null }
                    ]
                },
                {
                    role: "USUARIO_INTERNO",
                    acessos: [
                        { action: ["Acessar"], resource: "Aplicação", client: null },
                        { action: ["Listar"], resource: "Declaracao", client: null },
                        { action: ["Cadastrar"], resource: "Declaracao", client: null },
                        { action: ["Editar"], resource: "Declaracao", client: null }
                    ]
                },
                {
                    role: "FISCALIZACAO_CORREGEDORIA",
                    acessos: [
                        { action: ["Acessar"], resource: "Aplicação", client: null },
                        { action: ["Listar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Cadastrar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Editar"], resource: "Consulta Receita e Despesa", client: null }
                    ]
                },
                {
                    role: "JUIZ_DIRETOR_FORO",
                    acessos: [
                        { action: ["Acessar"], resource: "Aplicação", client: null },
                        { action: ["Listar"], resource: "Consulta Juiz Diretor de Foro", client: null },
                        { action: ["Cadastrar"], resource: "Consulta Juiz Diretor de Foro", client: null },
                        { action: ["Editar"], resource: "Consulta Juiz Diretor de Foro", client: null },

                        { action: ["Listar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Cadastrar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Editar"], resource: "Consulta Receita e Despesa", client: null }
                    ]
                },
                {
                    role: "ASSISTENTE_DIRETOR_FORO",
                    acessos: [
                        { action: ["Acessar"], resource: "Aplicação", client: null },
                        { action: ["Listar"], resource: "Consulta Assistente Diretor de Foro", client: null },
                        { action: ["Cadastrar"], resource: "Consulta Assistente Diretor de Foro", client: null },
                        { action: ["Editar"], resource: "Consulta Assistente Diretor de Foro", client: null },

                        { action: ["Listar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Cadastrar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Editar"], resource: "Consulta Receita e Despesa", client: null }
                    ]
                }
            ],
            roles: [
                {
                    role: {
                        id: "USUARIO_EXTERNO",
                        name: "Usuário Externo"
                    },
                    acessos: [
                        { action: ["Acessar"], resource: "Aplicação", client: null },
                        { action: ["Listar"], resource: "Declaracao", client: null },
                        { action: ["Cadastrar"], resource: "Declaracao", client: null },
                        { action: ["Editar"], resource: "Declaracao", client: null }
                    ]
                },
                {
                    role: {
                        id: "USUARIO_INTERNO",
                        name: "Usuário Interno"
                    },
                    acessos: [
                        { action: ["Acessar"], resource: "Aplicação", client: null },
                        { action: ["Listar"], resource: "Declaracao", client: null },
                        { action: ["Cadastrar"], resource: "Declaracao", client: null },
                        { action: ["Editar"], resource: "Declaracao", client: null }
                    ]
                },
                {
                    role: {
                        id: "FISCALIZACAO_CORREGEDORIA",
                        name: "Usuário Interno - GENOT"
                    },
                    acessos: [
                        { action: ["Acessar"], resource: "Aplicação", client: null },
                        { action: ["Listar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Cadastrar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Editar"], resource: "Consulta Receita e Despesa", client: null }
                    ]
                },
                {
                    role: {
                        id: "JUIZ_DIRETOR_FORO",
                        name: "Usuário Interno - Juiz de Foro"
                    },
                    acessos: [
                        { action: ["Acessar"], resource: "Aplicação", client: null },
                        { action: ["Listar"], resource: "Consulta Juiz Diretor de Foro", client: null },
                        { action: ["Cadastrar"], resource: "Consulta Juiz Diretor de Foro", client: null },
                        { action: ["Editar"], resource: "Consulta Juiz Diretor de Foro", client: null },

                        { action: ["Listar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Cadastrar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Editar"], resource: "Consulta Receita e Despesa", client: null }
                    ]
                },
                {
                    role: {
                        id: "ASSISTENTE_DIRETOR_FORO",
                        name: "Usuário Interno - Assistente Diretor de Foro"
                    },
                    acessos: [
                        { action: ["Acessar"], resource: "Aplicação", client: null },
                        { action: ["Listar"], resource: "Consulta Assistente Diretor de Foro", client: null },
                        { action: ["Cadastrar"], resource: "Consulta Assistente Diretor de Foro", client: null },
                        { action: ["Editar"], resource: "Consulta Assistente Diretor de Foro", client: null },

                        { action: ["Listar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Cadastrar"], resource: "Consulta Receita e Despesa", client: null },
                        { action: ["Editar"], resource: "Consulta Receita e Despesa", client: null }
                    ]
                }
            ]
        };

        /*  this.getJSON().subscribe(file => {
              this.file = file;
          });*/
    }

    public retornarAuthorizations(userToReturn): { action: string[]; resource: string; client?: string; }[] {
        let retorno = [] as { action: string[]; resource: string; client?: string; }[];

        if(this.file == undefined) {
            return retorno;
        }

        let rolesFile = this.file.roles as RolesFile[];
        //console.log('Valor do rolesFile => ', rolesFile);
        if (userToReturn.resource_access) {
            let recursosDeAcessoDoUsuario = userToReturn.resource_access[environment.settings.authentication.client_id];
            if (recursosDeAcessoDoUsuario) {
                let rolesUsuario = recursosDeAcessoDoUsuario.roles as string[];
                if (rolesUsuario.length > 0) {
                    //console.log('Valor das roles do usuário => ', rolesUsuario);
                    rolesUsuario.forEach(itemRoleUsuario => {
                        let roleConfig = rolesFile.find(roleFile => roleFile.role.id === itemRoleUsuario);
                        let possuiRoleConfigurada = roleConfig && roleConfig != null;
                        // Verificar neste ponto, a questão do acesso do Candidato/GENOT/EJEF
                        if (possuiRoleConfigurada) {
                            if (retorno.length <= 0) {
                                roleConfig.acessos.forEach(acesso => retorno.push(acesso));
                            } else {
                                roleConfig.acessos.forEach(acesso => {
                                    let possuiResouceAtribuido = retorno
                                        .filter(retornoAtribuido => retornoAtribuido.resource === acesso.resource).length > 0;

                                    if (possuiResouceAtribuido) {
                                        acesso.action.forEach(a => {
                                            let possuiAcaoAtribuida = retorno
                                                    .find(retornoAtribuido => retornoAtribuido.resource === acesso.resource).action &&
                                                retorno
                                                    .find(retornoAtribuido => retornoAtribuido.resource === acesso.resource).action.length > 0 &&
                                                retorno
                                                    .find(retornoAtribuido => retornoAtribuido.resource === acesso.resource).action
                                                    .includes(a);

                                            if (!possuiAcaoAtribuida)
                                                retorno
                                                    .find(retornoAtribuido => retornoAtribuido.resource === acesso.resource).action
                                                    .push(a)
                                        });
                                    } else {
                                        retorno.push(acesso);
                                    }
                                })
                            }
                        } else {
                            console.info(`Não existe configuração da Role ${itemRoleUsuario} do usuário`)
                        }
                    });
                } else {
                    console.info(`Usuário ${userToReturn.preferred_username} não possui Roles cadastradas no Keycloak`);
                    return [];
                }
            } else {
                console.info(`Usuário ${userToReturn.preferred_username} não possui acesso ao client do Keycloak`);
                return []
            }
        } else {
            console.info(`Recurso do Sistema não encontrado para o usuario ${userToReturn.preferred_username}`);
            return []
        }

        return retorno
            .map(auth => {
                auth.client = environment.settings.authentication.client_id;
                return auth;
            });
    }

    private getJSON(): Observable<any> {
        return this.http.get("assets/auth/auth.json");
    }

    obterRoles(roles: any): Role[] {
        if(this.file == undefined) {
            return [];
        }
        const filteredArr = this.file.roles.filter((el) => {
            return roles.some((f: string[]) => {
                return f === el.role.id;
            });
        }).map(each => { return each.role; });
        return filteredArr;
    }

}
